<template>
   <div class="row justify-content-start card-form-row py-3 my-3">
      <div class="col-2 my-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Año a consultar<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-12">
               <DropDown
                  v-model="idProcesoGeneral"
                  :options="procesosGenerales"
                  :filter="true"
                  panelClass="card-form-field-select"
                  optionLabel="ANIO"
                  optionValue="ANIO"
                  placeholder="Selecciona una opción"
                  emptyMessage="Sin datos"
                  class="w-100"
                  @change="sincronizar"
               />
            </div>
         </div>
      </div>
      <div class="col-2 my-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Ámbito<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-6">
               <span class="resultcard-link" style="cursor: pointer" v-tooltip.right="etiquetaFederal">
                  <RadioButton id="ambito" name="ambito" :value="1" v-model="ambito" @change="getComites" />
                  <label for="ambito" class="card-form-field-radio-label">Federal</label>
               </span>
            </div>
            <div class="col-6">
               <span class="resultcard-link" style="cursor: pointer" v-tooltip.right="etiquetaLocal">
                  <RadioButton id="ambito" name="ambito" :value="2" v-model="ambito" @change="getComites" />
                  <label for="ambito" class="card-form-field-radio-label">Local</label>
               </span>
            </div>
         </div>
      </div>
      <div class="col-5 my-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Comité del Partido</span>
            </div>
         </div>
         <div class="row">
            <div v-for="comite of comites" :key="comite.ID_ORGANIZACION" class="col-6 field-radiobutton">
               <RadioButton
                  :inputId="comite.ID_ORGANIZACION"
                  name="comite"
                  :value="comite.ID_ORGANIZACION"
                  v-model="idOrganizacion"
                  @change="getEntidades"
               />
               <label for="comite" class="card-form-field-radio-label">{{ comite.COMITEPARTIDO }}</label>
            </div>
         </div>
      </div>
      <div v-if="ambito > 1 || idOrganizacion > 1" class="col-3 my-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Entidad<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-12">
               <DropDown
                  v-model="idEstado"
                  :options="entidades"
                  :filter="true"
                  optionLabel="ESTADO"
                  optionValue="ID_ESTADO"
                  placeholder="Selecciona una entidad"
                  emptyMessage="Sin datos"
                  class="w-100"
                  @change="getSujetosObligados"
               />
            </div>
         </div>
      </div>
      <div class="col-3 my-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Actor político</span>
            </div>
         </div>
         <div class="row">
            <div class="col-12">
               <DropDown
                  v-model="idSujetoObligado"
                  :options="sujetosObligados"
                  :filter="true"
                  optionLabel="NOMBRE_ASOCIACION"
                  optionValue="ID_SUJETO_OBLIGADO"
                  placeholder="Todos los actores políticos"
                  emptyMessage="Sin datos"
                  class="w-100"
                  @change="sincronizar('DropDown')"
               />
            </div>
         </div>
      </div>
   </div>
</template>

<script setup>
import { defineProps, onMounted, ref, defineExpose } from "vue";
import FiltersOrdinarioDataService from "@/service/FiltersOrdinarioDataService";
import FiltersOrdinarioService from "@/service/FiltersOrdinarioService";

let idProcesoGeneral = ref();
let ambito = ref(1);
let idOrganizacion = ref(1);
let idEstado = ref(0);
let idSujetoObligado = ref(null);

let procesosGenerales = ref([]);
let comites = ref([]);
let entidades = ref([]);
let sujetosObligados = ref([]);

const secondary = ref(false);
const backendChecked = ref(false);

const etiquetaFederal = ref("Información de los partidos políticos nacionales");
const etiquetaLocal = ref("Información de los partidos políticos locales y nacionales con acreditación local");

const props = defineProps({
   checkAjax: Function,
   addAjax: Function,
   removeAjax: Function,
   load500Error: Function,
   sincronizarOrdinario: Function,
});

onMounted(() => {
   checkBackend();
});

const checkBackend = () => {
   //console.log("checkBackend: " + secondary.value);
   if (!backendChecked.value) {
      FiltersOrdinarioDataService.getInfo(secondary.value)
         .catch(() => {
            if (!secondary.value) {
               secondary.value = true;
               checkBackend();
            }
         })
         .finally(() => {
            backendChecked.value = true;
            init();
         });
   } else init();
};

const init = () => {
   getProcesosGenerales();
   getComites();
   props.checkAjax();
};

defineExpose({
   checkBackend,
});

const getProcesosGenerales = async () => {
   props.addAjax();
   await FiltersOrdinarioDataService.getProcesosGenerales(secondary.value)
      .then((res) => {
         procesosGenerales.value = res.data.body;
         if (procesosGenerales.value.length > 0) {
            const previousId = idProcesoGeneral.value;
            const searchItem = FiltersOrdinarioService.findProcesoGeneral(procesosGenerales.value, previousId);
            if (searchItem == undefined) idProcesoGeneral.value = procesosGenerales.value[0].ANIO;
            else idProcesoGeneral.value = searchItem.ANIO;
         } else {
            idProcesoGeneral.value = null;
         }
         getEntidades();
         sincronizar();
         props.removeAjax();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
      });
};

const getComites = async () => {
   props.addAjax();
   await FiltersOrdinarioDataService.getComites(secondary.value, ambito.value)
      .then((res) => {
         comites.value = res.data.body;
         if (comites.value.length > 0) {
            const previousId = idOrganizacion.value;
            const searchItem = FiltersOrdinarioService.findComite(comites.value, previousId);
            if (searchItem == undefined) idOrganizacion.value = comites.value[0].ID_ORGANIZACION;
            else idOrganizacion.value = searchItem.ID_ORGANIZACION;
         } else {
            idOrganizacion.value = null;
         }
         getEntidades();
         sincronizar();
         props.removeAjax();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
      });
};

const getEntidades = async () => {
   props.addAjax();
   await FiltersOrdinarioDataService.getEntidades(secondary.value, ambito.value, idOrganizacion.value)
      .then((res) => {
         entidades.value = res.data.body;
         if (entidades.value.length > 0) {
            const previousId = idEstado.value;
            const searchItem = FiltersOrdinarioService.findEntidad(entidades.value, previousId);
            if (searchItem == undefined) idEstado.value = entidades.value[0].ID_ESTADO;
            else idEstado.value = searchItem.ID_ESTADO;
         } else {
            idEstado.value = null;
         }
         getSujetosObligados();
         sincronizar();
         props.removeAjax();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
      });
};

const getSujetosObligados = async () => {
   props.addAjax();
   await FiltersOrdinarioDataService.getSujetosObligados(secondary.value, ambito.value, idOrganizacion.value, idEstado.value)
      .then((res) => {
         sujetosObligados.value = res.data.body;
         if (sujetosObligados.value.length > 0) {
            const previousId = idSujetoObligado.value;
            const searchItem = FiltersOrdinarioService.findSujetoObligado(sujetosObligados.value, previousId);
            if (searchItem == undefined) idSujetoObligado.value = sujetosObligados.value[0].ID_ESTADO;
            else idSujetoObligado.value = searchItem.ID_SUJETO_OBLIGADO;
         }
         if (idSujetoObligado.value == undefined) idSujetoObligado.value = null;
         props.removeAjax();
         sincronizar();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
      });
};

const sincronizar = () => {
   props.sincronizarOrdinario(idProcesoGeneral.value, ambito.value, idOrganizacion.value, idEstado.value, idSujetoObligado.value);
};
</script>
